import styled, { css } from 'styled-components';

const Divider = styled.div<{ vertical?: boolean; height?: number }>`
  ${({ vertical, height }) =>
    vertical
      ? css`
          border-right: 1px solid #ccc;
          height: ${height}px;
        `
      : css`
          height: 1px;
        `};
  background: #ebebeb;
`;

export default Divider;
